import { cn } from "@pharaday/lighthouse";
import type { ReactNode } from "react";

export type NavbarRootProps = {
  className?: string;
  children: ReactNode;
};

const Root = ({ children, className }: NavbarRootProps) => {
  return <div className={cn("flex h-[52px] items-center justify-between bg-white px-6", className)}>{children}</div>;
};

export default Root;
